import React, { useEffect } from "react";
import "./aboutUs.css";
import { useLanguage } from "../LanguageContext/LanguageContext";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import FlightIcon from "@mui/icons-material/Flight";
import PublicIcon from "@mui/icons-material/Public";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

function AboutUs() {
  const { lang, t } = useLanguage();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  useEffect(() => {
    document.querySelectorAll(".aboutUsPoint").forEach((el) => {
      el.style.direction = lang === "ar" ? "rtl" : "ltr";
    });
  }, [lang]);

  return (
    <div className="aboutUsGradBg">
      <div className="aboutUsWhiteBg">
        {/* <div className="gradiantCircle"></div> */}
        <div className="contentStyle">
          <h1 className="aboutUsTitle">
            {lang === "en" ? "About Us" : "من نحن"}
          </h1>
          <div className="companyDescContainer">
            <div className="aboutUsPoint">
              <LocalShippingIcon className="aboutUsIcons" />
              {t.aboutUs1}
            </div>
            <div className="aboutUsPoint">
              <ThumbUpAltIcon className="aboutUsIcons" />
              {t.aboutUs2}
            </div>
            <div className="aboutUsPoint">
              <FlightIcon className="aboutUsIcons" />
              {t.aboutUs3}
            </div>
            <div className="aboutUsPoint">
              <PublicIcon className="aboutUsIcons" />
              {t.aboutUs4}
            </div>
            <div className="aboutUsPoint" style={{ direction: lang === "ar" ? "rtl" : "ltr", alignItems: "flex-start" }}>
              <AutoAwesomeIcon className="aboutUsIcons" style={{ marginTop: "4px", flexShrink: 0 }} />
              <div>
                {t.aboutUsClosing.split("\n").map((line, i) =>
                  line === "" ? <br key={i} /> : <p key={i} style={{ margin: 0 }}>{line}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
